import styled from 'styled-components'

type StyledProps = {
  $loading?: boolean
}

const StyledLessonVideo = styled.div<StyledProps>`
  background-color: ${({ theme }) => theme.color.background};
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;
`

export default StyledLessonVideo
